import type { GridPosition, KnotBlockerState, MeasureTapeBlockerState } from 'game/boardMVC/types';
import { ConnectionStatus } from 'game/boardMVC/types';
import { Signal } from 'typed-signals';
import type { TileStackModel } from '../board/TileStackModel';

export class BlockerConnection {
  public status: ConnectionStatus = ConnectionStatus.Connected;

  public readonly onChange = new Signal();

  constructor(
    private readonly stack: TileStackModel,
    private readonly blockerState: KnotBlockerState | MeasureTapeBlockerState,
  ) {}

  public isConnectedTo(stack: TileStackModel): boolean {
    return this.blockerState.connectedTo.some((pos) => pos.x === stack.x && pos.y === stack.y);
  }

  public add(stack: TileStackModel): void {
    if (this.isConnectedTo(stack)) return;

    if (!this.stack.isNeighborOf(stack)) return;

    this.blockerState.connectedTo.push({ x: stack.x, y: stack.y });
    this.onChange.emit();
  }

  public remove(stack: TileStackModel): void {
    if (!this.isConnectedTo(stack)) return;
    const index = this.blockerState.connectedTo.findIndex((pos) => pos.x === stack.x && pos.y === stack.y);
    if (index !== -1) {
      this.blockerState.connectedTo.splice(index, 1);
      this.onChange.emit();
    }
  }

  public getAll(): GridPosition[] {
    return this.blockerState.connectedTo;
  }

  public get length(): number {
    return this.blockerState.connectedTo.length;
  }

  public clearAll(): GridPosition[] {
    const connections = this.getAll();
    this.blockerState.connectedTo = [];
    this.onChange.emit();

    return connections;
  }
}
